export default __webpack_public_path__ + "static/media/torso-mid-left-side.cc5b555a.png";